// @core/api/endpoints/team/transfer_team_ownership.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TransferTeamOwnershipRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Transfer team ownership
 * Transfers ownership from the current owner to a new user. The original owner loses ownership privileges.
 */
export async function TransferTeamOwnership(
  team_id: string,
  data: TransferTeamOwnershipRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/ownership/transfer`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
